import styled from 'styled-components'
import { CheckboxWrap } from 'ui/components/forms/Checkbox/styled.js'
import { breakpoints } from 'utils/constants'

export const Section = styled.div`
  position: relative;
  margin-top: 32px;

  @media ${breakpoints.mobileMax} {
    padding-bottom: 30px;
    margin-top: 16px;
  }
`

export const SectionForm = styled.div`
  margin-bottom: 20px;

  ${CheckboxWrap} {
    margin-bottom: 43px;

    @media ${breakpoints.mobileMax} {
      margin-top: 16px;
    }
  }

  @media ${breakpoints.mobileMax} {
    margin-bottom: 16px;
  }
`
export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 30px;
  justify-content: space-between;
`

export const TabNavWrapper = styled.div`
  margin-bottom: -15px;
  padding-top: 4px;
`

export const ButtonCell = styled.div`
  @media ${breakpoints.mobileMin} {
    min-width: 140px;
    
    &:not(:last-child) {
      min-width: 169px;
      margin-right: 8px;
    }

  @media ${breakpoints.mobileMax} {
    margin: 0 4px;
  }
`
